export default "__VITE_ASSET__CMJk3S$B__"